import Alert from "./components/Alert.vue";
import AlertModal from "./components/AlertModal.vue";
import AutoComplete from "./components/AutoComplete.vue";
import CollegeMail from "./components/CollegeMail.vue";
import CollegeValidator from "./components/CollegeValidator.vue";
import CommentDeleteModal from "./components/CommentDeleteModal.vue";
import CommentPanel from "./components/CommentPanel.vue";
import CommentPostField from "./components/CommentPostField.vue";
import CommentReportModal from "./components/CommentReportModal.vue";
import CommentRow from "./components/CommentRow.vue";
import CommentSmileySelector from "./components/CommentSmileySelector.vue";
import CommentUsernameModal from "./components/CommentUsernameModal.vue";
import CommentYtModal from "./components/CommentYtModal.vue";
import ConfirmModal from "./components/ConfirmModal.vue";
import DecoratorInput from "./components/DecoratorInput.vue";
import Dropdown from "./components/Dropdown.vue";
import FavoriteButton from "./components/FavoriteButton.vue";
import FloatButtons from "./components/FloatButtons.vue";
import FormControlCounter from "./components/FormControlCounter.vue";
import FullModal from "./components/FullModal.vue";
import FuncPanel from "./components/FuncPanel.vue";
import HeadMarquee from "./components/HeadMarquee.vue";
import IdNumberModal from "./components/IdNumberModal.vue";
import InformModal from "./components/InformModal.vue";
import JobCategory from "./components/JobCategory.vue";
import JobType from "./components/JobType.vue";
import LikeButton from "./components/LikeButton.vue";
import Location from "./components/Location.vue";
import LoginButton from "./components/LoginButton.vue";
import LoginModal from "./components/LoginModal.vue";
import LogoutButton from "./components/LogoutButton.vue";
import MainHeader from "./components/MainHeader.vue";
import MemberAvatar from "./components/MemberAvatar.vue";
import MemberBirthday from "./components/MemberBirthday.vue";
import MemberMail2 from "./components/MemberMail2.vue";
import MemberMobile2 from "./components/MemberMobile2.vue";
import MemberName from "./components/MemberName.vue";
import NicknamePicker from "./components/NicknamePicker.vue";
import PageSpace from "./components/PageSpace.vue";
import PartFollowButton from "./components/PartFollowButton.vue";
import PartPicker from "./components/PartPicker.vue";
import PartRule from "./components/PartRule.vue";
import PartSearch from "./components/PartSearch.vue";
import PartSearchBar from "./components/PartSearchBar.vue";
import PartSearchInput from "./components/PartSearchInput.vue";
import PillboxInput from "./components/PillboxInput.vue";
import PopupAds from "./components/PopupAds.vue";
import RangeBar from "./components/RangeBar.vue";
import ReportModal from "./components/ReportModal.vue";
import SearchBar from "./components/SearchBar.vue";
import SearchCollegeOpts from "./components/SearchCollegeOpts.vue";
import SearchPostOpts from "./components/SearchPostOpts.vue";
import Select2 from "./components/Select2.vue";
import ShareLink from "./components/ShareLink.vue";
import SignModal from "./components/SignModal.vue";
import SlickJs from "./components/SlickJs.vue";
import StarRatingInput from "./components/StarRatingInput.vue";
import StarRatingInputPure from "./components/StarRatingInputPure.vue";
import StarScore from "./components/StarScore.vue";
import StepBar from "./components/StepBar.vue";
import Tooltip from "./components/Tooltip.vue";
import TopicCommentField from "./components/TopicCommentField.vue";
import TopicCommentPanel from "./components/TopicCommentPanel.vue";
import TopicCommentRow from "./components/TopicCommentRow.vue";
import TopicContent from "./components/TopicContent.vue";
import TopicDraftPicker from "./components/TopicDraftPicker.vue";
import TopicEditor from "./components/TopicEditor.vue";
import TopicFavoriteButton from "./components/TopicFavoriteButton.vue";
import TopicImage from "./components/TopicImage.vue";
import TopicInformModal from "./components/TopicInformModal.vue";
import TopicInput from "./components/TopicInput.vue";
import TopicLikeButtons from "./components/TopicLikeButtons.vue";
import TopicOtherButtons from "./components/TopicOtherButtons.vue";
import TopicPreview from "./components/TopicPreview.vue";
import TopicRemoveButton from "./components/TopicRemoveButton.vue";
import TopicRemoveModal from "./components/TopicRemoveModal.vue";
import TopicTagEditor from "./components/TopicTagEditor.vue";
import Worktime from "./components/Worktime.vue";
import YtPlayer from "./components/YtPlayer.vue";

const components = {
    Alert,
    AlertModal,
    AutoComplete,
    CollegeMail,
    CollegeValidator,
    CommentDeleteModal,
    CommentPanel,
    CommentPostField,
    CommentReportModal,
    CommentRow,
    CommentSmileySelector,
    CommentUsernameModal,
    CommentYtModal,
    ConfirmModal,
    DecoratorInput,
    Dropdown,
    FavoriteButton,
    FloatButtons,
    FormControlCounter,
    FullModal,
    FuncPanel,
    HeadMarquee,
    IdNumberModal,
    InformModal,
    JobCategory,
    JobType,
    LikeButton,
    Location,
    LoginButton,
    LoginModal,
    LogoutButton,
    MainHeader,
    MemberAvatar,
    MemberBirthday,
    MemberMail2,
    MemberMobile2,
    MemberName,
    NicknamePicker,
    PageSpace,
    PartFollowButton,
    PartPicker,
    PartRule,
    PartSearch,
    PartSearchBar,
    PartSearchInput,
    PillboxInput,
    PopupAds,
    RangeBar,
    ReportModal,
    SearchBar,
    SearchCollegeOpts,
    SearchPostOpts,
    Select2,
    ShareLink,
    SignModal,
    SlickJs,
    StarRatingInput,
    StarRatingInputPure,
    StarScore,
    StepBar,
    Tooltip,
    TopicCommentField,
    TopicCommentPanel,
    TopicCommentRow,
    TopicContent,
    TopicDraftPicker,
    TopicEditor,
    TopicFavoriteButton,
    TopicImage,
    TopicInformModal,
    TopicInput,
    TopicLikeButtons,
    TopicOtherButtons,
    TopicPreview,
    TopicRemoveButton,
    TopicRemoveModal,
    TopicTagEditor,
    Worktime,
    YtPlayer
};

export default {
    install: (app) => {
        for (const name in components) {
            app.component(name, components[name]);
        }
    }
};
